import { Component } from './Component';

class SelectedComponentData {
    componentRef: string = "";
    component: Component | null = null;
    rowIndex: number;
    colIndex: number;

    constructor(componentRef: string, component: Component | null | undefined, rowIndex: number, colIndex: number) {
        this.componentRef = componentRef
        this.component = component ? component : null;
        this.rowIndex = rowIndex ? rowIndex : 0;
        this.colIndex = colIndex ? colIndex : 0;
    }
}

export { SelectedComponentData };